
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./AddInvoiceComponent.module.scss";
import TableAndSearch from "./common/TableAndSearch";
import { Link, useHistory } from "react-router-dom";
import { getRequest as getEnterprise } from "services/axiosBaseClient";
// import NewTableAndSearchMaster from "./common/NewTableAndSearchMaster";
import NewTableAndSearchMasterFilter from "./common/NewTableAndSearchMasterFilter";

var pageNumber = 1;
var pageSizee = 10;
var pagingString = "&pageNumber=" + pageNumber + "&pageSize=" + pageSizee;
var tempTigger;

function InvoiceView(props) {
  const history = useHistory();
  const [invoiceData, setInvoiceData] = useState([]);
  const [swapStationCount, setSwapStationCount] = useState("");
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    tempTigger = !history?.location?.state?.compomentRenderType
      ? "init"
      : history?.location?.state?.compomentRenderType === "amhitted"
      ? "amhitted"
      : history?.location?.state?.compomentRenderType === "view"
      ? "view"
      : "init";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  const paginationCountHanlde = (offsett, limit, tigger, string) => {
    
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 0 : offsett;
    pageNumber = testCount;
    pageSizee = limit
    pagingString = "&pageNumber=" + testCount + "&pageSize=" + limit;
  };

  const pageLimitHandle = (offsett, limit, tigger, tempHeaderFilter) => {
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 1 : offsett;
    pageNumber = offsett;
    pageSizee = limit
    // searchSwapStationByFilter(tempHeaderFilter);
  };

  const getInvoiceList = useCallback(async (searchString) => {
  
    await getEnterprise("bss/getInvoiceList?"+searchString)
      .then((res) => {
        if (res && res?.data) {
          setInvoiceData(res?.data?.invoiceList);
          setSwapStationCount(res?.data?.pagination?.totalRecords);
        } else {
          setInvoiceData([]);
          setSwapStationCount(0);
        }
      })
      .catch((err) => {
        setInvoiceData([]);
        console.error("Error", err);
      });
  }, []);

  

  const updateInvoiceHandle = (data) => {
    data.row.original.invoiceno
      ? history.push("/Invoice/UpdateInvoice/" + data.row.original.invoiceno)
      : history.push("/Invoice/AddInvoice/");
  };

  const viewInvoiceHandle = (data) => {
    const test = localStorage.setItem("saveViewTigger", true);

    data.row.original.invoiceno
      ? history.push(
          "/Invoice/ViewInvoice/" + data.row.original.invoiceno + "/view"
        )
      : history.push("/Invoice/AddInvoice/");
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Invoice No.",
        accessor: "invoiceno",
      },
      {
        Header: "Driver Name",
        accessor: "drivername",
      },
      {
        Header: "VIN",
        accessor: "vin",
      },
      // {
      //   Header: "RFID No.",
      //   accessor: "rfidno",
      // },
      {
        Header: "Energy Exchange(kWh)",
        accessor: "energyexchanged",
        Cell: (row) => { 
          return(
            <div style={{ paddingLeft:"30px" }}>{row.row?.original?.energyexchanged? row.row?.original?.energyexchanged : 0}</div>
        ) },
      },
      {
        Header: "Inv Amt(₹)",
        accessor: "invamount",
      },
      {
        Header: "Swap Time",
        accessor: "swaptime",
      },
      {
        Header: "Swap Site",
        accessor: "swapsite",
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (row) => {
          return (
            <>
              {/* <Link to= "/Invoice/ViewInvoice"> */}
              <img
                src={require("assets/view.png").default}
                style={{ marginRight: 15, cursor: "pointer" }}
                onClick={() =>
                  // updateInvoiceHandle(row.value, row.row.original.enterprise)
                  viewInvoiceHandle(row)
                }
              />
              {/* </Link> */}
              <img
                src={require("assets/pencil.png").default}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  // updateInvoiceHandle(row.value, row.row.original.enterprise)
                  updateInvoiceHandle(row)
                }
              ></img>
            </>
          );
        },
      },
    ],
    []
  );

  function formatSwapTime(swapTimeString) {
    if (swapTimeString) {
      const [datePart, timePart] = swapTimeString.split(' ');
      const [day, month, year] = datePart.split('-');
      const formattedDate = `${day}-${month}-${'20' + year}`;
      return `${formattedDate} ${timePart}`;
    }
    return '';
  }

  var swappedSessionData = [];

  invoiceData.map((item) => {
    swappedSessionData.push({
      invoiceno: item?.invoiceNumber,
      drivername: item?.driverName,
      vin: item?.vin,
      rfidno: item?.rfid,
      energyexchanged: item?.energyExchange? Number(item?.energyExchange).toFixed(2) : 0,
      invamount: item?.invAmt ? Number(item?.invAmt).toFixed(2) : 0,
      swaptime: formatSwapTime(item?.swapTime) || '',
      swapsite: item?.swapSite,
    });
  });

  var searchByKey = (searchString) => {
    if (searchString === undefined) {
      return getInvoiceList();
    }
    getEnterprise(
      "bss/getInvoiceList?invoiceNumber=" +
        searchString +
        "&pageNumber=1&pageSize=10"
    )
      .then((res) => {
        if (res?.statusCode === 200) {
          setInvoiceData(res?.data?.invoiceList);
        }
      })
      .catch((err) => {
        if (err) {
          setInvoiceData([]);
        }
        console.error("Error", err);
      });
  };

  


  return (
    <>
      <div id="Invoice_list_block" className={cn(styles.flex_item1)}>
        <div id="Invoice_list_layout" className={cn(styles.flex1)}>
          <h2 id="Invoice_list_header" className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Invoice List"}
          </h2>
          <NewTableAndSearchMasterFilter
        searchOpts={{
          placeholder: "Search by invoice No",
          filter: false,
          onFilterSearch: getInvoiceList,
          screentype: "swapping",
          addInvoice: false,
        }}
        headerFilter={props.headerFilter}
        columns={columns}
        paginationDoubleScreen={true}
        data={swappedSessionData}
        swapStationCount={swapStationCount}
        pageLimitHandle={pageLimitHandle}
        paginationCountHanlde={paginationCountHanlde}
        _id={"alert"}
      />
        </div>
      </div>
    </>
  );
}

export default function Invoice(props) {
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master
        opts={props}
        screen={InvoiceView}
        showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

Invoice.inStorybook = true;
